import React, { useState, useEffect, useCallback } from 'react';
import ReactPlayer from 'react-player';
import { raps, Rap } from '../data';
import * as S from './styles';

interface ModalProps {
  rapId: number | undefined;
  onClose: () => void;
}
const Modal: React.FC<ModalProps> = ({ rapId, onClose }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [rap, setRap] = useState<Rap | undefined>(undefined);

  const handleClose = useCallback(() => {
    setIsOpen(false);
    onClose();
  }, [onClose]);

  const renderVideo = useCallback(() => {
    if (!rap) return <></>;

    return (
      <ReactPlayer
        url={rap.video}
        width={'100%'}
        height={'100%'}
        className="react-player"
        controls
      />
    );
  }, [rap]);

  useEffect(() => {
    if (rapId) {
      setIsOpen(true);
      setRap(raps.find((rap) => rap.id === rapId));
    } else {
      setIsOpen(false);
      setRap(undefined);
    }
  }, [rapId]);

  return (
    <S.Container isOpen={isOpen}>
      <S.Content>
        <S.Video>
          <S.VideoWrapper>{renderVideo()}</S.VideoWrapper>
        </S.Video>
        <S.Infos>
          <S.InfoHeader>
            <S.InfoTitle>{rap?.title}</S.InfoTitle>
            <S.CloseButton onClick={handleClose}>
              <S.CloseIcon />
            </S.CloseButton>
          </S.InfoHeader>
          <S.InfoText
            dangerouslySetInnerHTML={{ __html: rap?.description || '' }}
          ></S.InfoText>
        </S.Infos>
        <S.VideoMobile>
          <S.VideoWrapper>{renderVideo()}</S.VideoWrapper>
        </S.VideoMobile>
      </S.Content>
    </S.Container>
  );
};

export default Modal;
